import * as api from '../api';
import { FETCH_ALL, CREATE, UPDATE, DELETE } from '../constants/actionTypes';

export const getProjects = () => async (dispatch) => {
    try {
        const response = await api.getProjects();
        dispatch({type: FETCH_ALL, payload: response});
    } catch (error) {
        console.log(error.message);
    }
}

export const createProjects = (project) => async (dispatch) => {
    try {
        const response = await api.createProjects(project);
        dispatch({type: CREATE, payload: response});
    } catch (error) {
        console.log(error);
    }
}

export const updateProject = (id, project) => async (dispatch) => {
    try {
        const {data} = await api.updateProject(id, project);
        console.log(data)
        dispatch({type: UPDATE, payload: data});
    } catch (error) {
        console.log(error);
    }
}

export const deleteProject = (id) => async (dispatch) => {
    try {
        await api.deleteProject(id);

        dispatch({type: DELETE, payload: id});
    } catch (error) {
        console.log(error);
    }
}

export const shortlistProject = (id, project) => async (dispatch) => {
    try {
        const {data} = await api.shortlistProject(id, project);
        dispatch({type: UPDATE, payload: data});
    } catch (error) {
        
    }
}